import { getCurrentThemeId } from 'owa-theme';

export default function isDefaultTheme(): boolean {
    return getCurrentThemeId() === 'base';
}
